// extracted by mini-css-extract-plugin
export default {"info":"ImgZoomModal_info__42rHP","title":"ImgZoomModal_title__lJ0QB"};